import { render, staticRenderFns } from "./BetgameType.vue?vue&type=template&id=215da091&scoped=true"
import script from "./BetgameType.vue?vue&type=script&lang=js"
export * from "./BetgameType.vue?vue&type=script&lang=js"
import style0 from "./BetgameType.vue?vue&type=style&index=0&id=215da091&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215da091",
  null
  
)

export default component.exports